import { Component, ViewChild, ViewContainerRef, OnInit } from "@angular/core";
import { FormControl, NgForm } from "@angular/forms";
import { FieldWrapper } from "@ngx-formly/core";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "file-wrapper-lite",
  templateUrl: "./file-wrapper-lite.component.html",
  styleUrls: ["./file-wrapper-lite.component.css"],
  
})
export class FileWrapperLiteComponent extends FieldWrapper implements OnInit {
  // @ViewChild(NgForm) fieldComponent;

  @ViewChild("fieldComponent", { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;

  maxFileSize: number;
  maxFileSizeMB: number;
  maxSizeCaption: string;
  selectedFiles: FileList;
  fileName: string;

  constructor(private toastrService: ToastrService) {
    super();
  }

  ngOnInit(): void {
    this.maxFileSizeMB = +this.to.attributes["maxSize"];
    this.maxFileSize = this.maxFileSizeMB * 2 ** 20;
    this.maxSizeCaption = <string>this.to.attributes["extraDesc"];
  }

  resetFile(){
    this.to.fileName = "";
    if(this.to.reset)
      this.to.reset(null);
  }

  detectFiles(event) {
    this.selectedFiles = event.target.files;
    if (this.selectedFiles.length === 0) {
      return;
    }
    if (this.selectedFiles[0].size <= this.maxFileSize) {
      this.to.fileName = this.selectedFiles[0]
        ? this.selectedFiles[0].name
        : "";
      if (this.to.callback && this.to.fileName) {
        this.to.callback(event);
      }
    } else {
      this.toastrService.error("", "The file exceeds the maximum size allowed");
    }
  }
}
